export default __webpack_public_path__ + "static/media/aircall.44b92e51.svg";